/**
 * An (i) note next to a selling point. Hover and keyboard focus show it through CSS;
 * this adds tap-to-toggle for touch screens and Escape to close.
 */
class FaInfoTip extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#toggle);
    this.addEventListener('keydown', this.#onKeydown);
    this.addEventListener('mouseleave', this.#reset);
    this.addEventListener('focusout', this.#reset);
    document.addEventListener('click', this.#onDocumentClick);
  }

  disconnectedCallback() {
    this.removeEventListener('mouseleave', this.#reset);
    this.removeEventListener('focusout', this.#reset);
    this.removeEventListener('click', this.#toggle);
    this.removeEventListener('keydown', this.#onKeydown);
    document.removeEventListener('click', this.#onDocumentClick);
  }

  /** @param {Event} event */
  #toggle = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.fa-info-tip__button')) return;
    this.#setOpen(!this.hasAttribute('data-open'));
  };

  /** @param {KeyboardEvent} event */
  #onKeydown = (event) => {
    if (event.key !== 'Escape') return;
    // Escape also hides a note opened by hover or focus, until the pointer or focus leaves
    this.#setOpen(false);
    this.setAttribute('data-dismissed', '');
  };

  #reset = () => {
    this.removeAttribute('data-dismissed');
  };

  /** @param {Event} event */
  #onDocumentClick = (event) => {
    if (event.target instanceof Node && !this.contains(event.target)) this.#setOpen(false);
  };

  /** @param {boolean} open */
  #setOpen(open) {
    this.toggleAttribute('data-open', open);
    this.querySelector('button')?.setAttribute('aria-expanded', String(open));
  }
}

if (!customElements.get('fa-info-tip')) {
  customElements.define('fa-info-tip', FaInfoTip);
}
